import * as React from "react";
import { IconGripVertical } from "@tabler/icons-react";
import * as ResizablePrimitive from "react-resizable-panels";

import { cn } from "../../utils";

const ResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) => (
  <ResizablePrimitive.PanelGroup
    className={cn(
      "al-flex al-h-full al-w-full data-[panel-group-direction=vertical]:al-flex-col",
      className
    )}
    role="group"
    aria-label="resizable-panel-group"
    {...props}
  />
);

const ResizablePanel = ({
  className,
  minSize,
  maxSize,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.Panel>) => (
  <ResizablePrimitive.Panel
    className={cn("al-group al-relative", className)}
    role="region"
    aria-label="resizable-panel"
    {...props}
    data-panel-min-size={minSize}
    data-panel-max-size={maxSize}
  />
);

const ResizableHandle = ({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
}) => {
  const isVertical = props["data-panel-group-direction" as keyof typeof props] === "vertical";
  return (
    <ResizablePrimitive.PanelResizeHandle
      className={cn(
        "al-relative al-flex al-w-px al-items-center al-justify-center al-bg-border after:al-absolute after:al-inset-y-0 after:al-left-1/2 after:al-w-1 after:al--translate-x-1/2 focus-visible:al-outline-none focus-visible:al-ring-1 focus-visible:al-ring-ring focus-visible:al-ring-offset-1 data-[panel-group-direction=vertical]:al-h-px data-[panel-group-direction=vertical]:al-w-full data-[panel-group-direction=vertical]:after:al-left-0 data-[panel-group-direction=vertical]:after:al-h-1 data-[panel-group-direction=vertical]:after:al-w-full data-[panel-group-direction=vertical]:after:al-translate-y-1/2 data-[panel-group-direction=vertical]:after:al-translate-x-0 [&[data-panel-group-direction=vertical]>div]:al-rotate-90",
        className
      )}
      role="separator"
      aria-label="resize-handle"
      aria-orientation={isVertical ? "horizontal" : "vertical"}
      {...props}
    >
      {withHandle && (
        <div
          className="al-z-10 al-flex al-h-4 al-w-3 al-items-center al-justify-center al-rounded-sm al-border al-bg-border"
          aria-hidden="true"
          aria-label="resize grip"
        >
          <IconGripVertical className="al-h-2.5 al-w-2.5" />
        </div>
      )}
    </ResizablePrimitive.PanelResizeHandle>
  );
};

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
